import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { FormInstance } from "../models/FormInstance";

type Props = {
	setSelectedRowData: (formInstance: FormInstance | null) => void;
	setShowModal: (modal: "create" | "edit" | "view" | "delete" | "") => void;
	dowloandPdfs: (formInstance: FormInstance) => void;
	deleteForms: (formInstance: FormInstance) => void;
};
export const useFormInstanceOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
	dowloandPdfs,
	deleteForms,
}: Props) => {
	const getMenuOptions = (data: FormInstance) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Form",
				key: "new_form_instance",
				onClick: () => {
					setSelectedRowData(null);
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data.SubmitTimestamp != null) {
			options = options.concat([
				{
					name: "View Answers",
					key: "view_answers",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("view");
					},
					icon: <VisibilityIcon />,
				},
			]);
		} else {
			options = options.concat([
				{
					name: "Edit Form",
					key: "edit_form_instance",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("edit");
					},
					icon: <EditIcon />,
				},
			]);
		}
		if (data) {
			options = options.concat([
				{
					name: `Delete Form`,
					key: "delete_form_instance",
					onClick: () => {
						deleteForms(data);
					},
					icon: <DeleteIcon />,
				},
				/* {
          name: `Dowloand PDF`,
          key: "download_form_pdf",
          onClick: () => {
            dowloandPdfs(data);
          },
          icon: <FileDownloadIcon />,
        }, */
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
